export enum LinkedInRedirectType {
    LOGIN = "Login",
    REGISTER = "Register"
}